import { gql } from '@apollo/client'

export const SelectedQuery = gql`
  query SelectedManufacturerVehicleSelector($companyId: ID!) {
    vehicles(companyId: $companyId) {
      manufacturers
    }
  }
`
